
//Create, update
export class NewsFilterRequest{
    name: string;
    
}

export class NewsFilterRequestSearch{
    name: string;
    pageNumber: number;
    pageSize: number;
    published: boolean;
    sortBy: string;
    
}